var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyesDryEyes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 113.39 113.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-dryeyes,.cls-4-dryeyes,.cls-5-dryeyes{fill:none;}.cls-2-dryeyes{fill:#a64daa;}.cls-3-dryeyes{clip-path:url(#clip-path);}.cls-4-dryeyes,.cls-5-dryeyes{stroke:#a64daa;stroke-linecap:round;stroke-linejoin:round;}.cls-4-dryeyes{stroke-width:3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-dryeyes",
    x: 9.56,
    y: 23.92,
    width: 84.04,
    height: 56.93
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-dryeyes",
    d: "M11.94,51.46a1.9,1.9,0,0,1-.61-.1,2.11,2.11,0,0,1-1.41-1.82C7.47,36.92,15.84,30.15,21.17,28.15c25.14-9.46,48.39-.73,65.36,5.65l1.69.64a1.5,1.5,0,0,1-.9,2.85C40.4,25.14,22.42,42.41,15.65,48.92,14,50.53,13,51.46,11.94,51.46ZM44.3,27A62.06,62.06,0,0,0,22.23,31a15.21,15.21,0,0,0-9.59,16.69c.3-.28.63-.59.93-.89A53.48,53.48,0,0,1,35.29,33.38c9.52-3.11,20.54-4,32.93-2.69A87,87,0,0,0,44.3,27Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3-dryeyes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4-dryeyes",
    d: "M84.73,68.32a10.56,10.56,0,0,0-13,.08,25.38,25.38,0,0,1-10.82,5.53,26.57,26.57,0,0,1-8.53.45c-2-.17-3.42-.5-11.22-2.69l-6.49-1.85A29.87,29.87,0,0,0,29.2,68.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-dryeyes",
    d: "M63.14,73.29c1.32.22,6.33,1.19,8,5.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-dryeyes",
    d: "M17.74,63.45c1.73-.31,4-.8,6.73-1.54,5.71-1.59,15.84-7.45,21.09-9.14,5.87-1.9,12.1-2.63,17.44-.16,14,6.46,11.1,3.09,15.13,6.16.62.47,4.94.53,8.42-1.19a42.13,42.13,0,0,0,5.55-4.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-dryeyes",
    d: "M69.7,70.1A8.83,8.83,0,0,1,78.49,74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-dryeyes",
    d: "M57.48,74.45s3.13,1.65,2.46,4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-dryeyes",
    d: "M21.46,71.86a39.21,39.21,0,0,1,7.29,1.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-dryeyes",
    d: "M71.66,68.52c.66-.6,1.65-1.49,2.86-2.52l0,0a26,26,0,0,0,4.2-8.08l.36-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-dryeyes",
    d: "M66.15,56.42a10.69,10.69,0,1,1-19.33-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-dryeyes",
    d: "M73.67,56.34s8.34,1.5,9.64-3.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-dryeyes",
    d: "M67.12,53.82s6.9-.58,8.28-4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-dryeyes",
    d: "M60.36,60.17A4.47,4.47,0,1,1,55.9,55.7a4.46,4.46,0,0,1,4.46,4.47h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5-dryeyes",
    d: "M25.59,49a39,39,0,0,1,7.13-2c2.8-.49,3.7-.33,9.36-.87,3.52-.33,5.31-.5,7.61-.92A52.56,52.56,0,0,0,58,43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5-dryeyes",
    d: "M48,40.83a38.83,38.83,0,0,1,7.39-.08c2.84.23,3.67.61,9.28,1.52,3.49.57,5.27.86,7.59,1a53.15,53.15,0,0,0,8.65-.07"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyesDryEyes);
export default __webpack_public_path__ + "static/media/eyes-dry-eyes.88f1c34f.svg";
export { ForwardRef as ReactComponent };